import de from 'date-fns/locale/de'
import enGB from 'date-fns/locale/en-GB'
import enUS from 'date-fns/locale/en-US'
import es from 'date-fns/locale/es'
import fr from 'date-fns/locale/fr'
import nl from 'date-fns/locale/nl'
import React from 'react'
import { Image as DatoImage } from 'react-datocms'
import cn from 'classnames'

//
import { IconNew } from '../../storybook'
import { getMicroCopy } from '../../utils/microcopy'
import { SiteDataContext } from '../page-wrapper'
import { useMicroCopyData } from '@/src/context/MicroCopyContext'
import { NavLink } from '@/src/storybook/helpers'
import { THEME } from '@/src/utils/common'

const validLocales = { en: enGB, de: de, fr: fr, es: es, nl: nl, us: enUS }

const RelatedArticles = ({
  articles,
  slugPrefix = 'en',
  title = '',
  _preface = '',
  locales = '',
  theme = THEME.light
}) => {
  if (!articles?.length) {
    return null
  }

  let locale = locales || slugPrefix.split('-')[0] || 'en'
  if (!validLocales[locale]) {
    locale = 'en'
  }

  const microCopyData = useMicroCopyData()
  const { lang, isTextRtl } = React.useContext(SiteDataContext)

  /* const relatedArticles =
    getArticleItems(articles, slugPrefix, locale, microCopyData[lang], validLocales) || [] */

  return (
    <section
      className={cn('l-section', {
        'l-section--dark': theme === THEME.dark
      })}
      dir={isTextRtl ? 'rtl' : 'ltr'}
    >
      <div className="l-container:12/12 l-container--default-spacing">
        <h2 className="l-container:6/12 c-related-articles__title">{title}</h2>
        <div className="c-related-articles">
          {articles.map((article) => (
            <NavLink
              key={article.id}
              to={
                article.__typename === 'CustomerModelRecord'
                  ? `/${slugPrefix}/customers/${article.slug}`.replace(/\/{2,}/gim, '/')
                  : `/${slugPrefix}/blog/${article.categories?.[0]?.slug}/${article.slug}`.replace(
                      /\/{2,}/gim,
                      '/'
                    )
              }
            >
              <div className="c-related-articles__card">
                <div className="c-related-articles__card__background">
                  <DatoImage
                    data={article.image.responsiveImage || article.image}
                    imgStyle={{
                      objectFit: 'cover'
                    }}
                    style={{
                      height: '100%',
                      width: '100%'
                    }}
                  />
                </div>
                <div className="c-related-articles__card__content">
                  <div className="c-related-articles__card__icon-container">
                    <div className="c-related-articles__card__icon">
                      <IconNew name="ti-arrow-narrow-up" />
                    </div>
                  </div>
                  <div className="c-related-articles__card__title-container">
                    <div className="c-related-articles__card-type">
                      {article.__typename === 'CustomerModelRecord'
                        ? getMicroCopy({
                            key: `testimonial`,
                            data: microCopyData[lang]
                          })
                        : getMicroCopy({
                            key: `article`,
                            data: microCopyData[lang]
                          })}
                    </div>
                    <div className="c-related-articles__card-title">{article.title}</div>
                  </div>
                </div>
              </div>
            </NavLink>
          ))}
        </div>
      </div>
    </section>
  )
}

export default RelatedArticles
